import { ONE_HOUR_MS, ONE_MINUTE_MS, ONE_SECOND_MS } from '@shared/utils';

export const DEFAULT_WATCH_RECOMMENDATIONS_INTERVAL_MS = ONE_MINUTE_MS * 15;
export const LEARNING_COMPLETED_WATCH_RECOMMENDATIONS_INTERVAL_MS = ONE_SECOND_MS * 45;
export const LEARNING_COMPLETED_WATCH_RECOMMENDATIONS_TIMEOUT_MS = ONE_MINUTE_MS;

export const DEFAULT_WATCH_STUDENT_BALANCE_INTERVAL_MS = ONE_MINUTE_MS * 10;
export const LEARNING_COMPLETED_WATCH_STUDENT_BALANCE_INTERVAL_MS = ONE_SECOND_MS * 20;
export const LEARNING_COMPLETED_WATCH_STUDENT_BALANCE_TIMEOUT_MS = ONE_MINUTE_MS;

export const DEFAULT_WATCH_LAST_LEARNING_ACTIVITY_TIME = ONE_HOUR_MS;

export const DEFAULT_WATCH_THIRD_PARTY_APP_CREDENTIALS_INTERVAL_MS = ONE_HOUR_MS;
